export default class LocalStorageHelper {
  static get = key => {
    try {
      return JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
      return null;
    }
  };

  static set = (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value));
    
    // Dispatch custom event for pattern fill changes to notify React components
    if (key === 'applyPatternFill') {
      const event = new CustomEvent('patternFillChanged', { 
        detail: { value } 
      });
      window.dispatchEvent(event);
    }
  };
}
